import { fork } from 'redux-saga/effects';

import { watcher as createPatientWatcher } from './create-patient';
import { watcher as getUserWatcher } from './get-user';
import { watcher as getLoggedUserWatcher } from './get-logged-user';
import { watcher as getTeamUserWatcher } from './get-team-user';
import { watcher as getProviderWatcher } from './get-provider';
import { watcher as getProviderMemberWatcher } from './get-provider-member';
import { watcher as getFamilyMemberWatcher } from './get-family-member';
import { watcher as editUserWatcher } from './edit-user';
import { watcher as editAvatarWatcher } from './edit-avatar';
import { watcher as editPatientWatcher } from './edit-patient';
import { watcher as editPatientByProviderWatcher } from './edit-patient-by-provider';
import { watcher as editProviderWatcher } from './edit-provider';
import { watcher as editEmailWatcher } from './edit-email';
import { watcher as editMobilePhoneWatcher } from './edit-mobile-phone';
import handleDocumentsErrorsSaga from './handle-documents-error-saga';
import { watcher as confirmMobilePhoneWatcher } from './confirm-mobile-phone';
import { updateAvatarSaga } from './updateAvatarSaga';
import { watcher as getParentMemberWatcher } from './get-parent-provider';
import { watcher as changeSettingsWatcher } from './change-settings';
import { watcher as changeProfileReqWatcher } from './change-profile-req';
import { updateProfileSaga } from './updateProfileSaga';
import { watcher as addPatientByProviderWatcher } from './addPatientByProvider';
import { watcher as getAccessLevelsWatcher } from './getAccessLevels';
import { watcher as publicProfileWatcher } from './public-profile';
import { watcher as getUserDocuments } from './get-user-documents';
import { watcher as getUserAttachments } from './get-user-attachment';
import { watcher as updateUserDocuments } from './update-user-documents';
import { watcher as uploadUserDocuments } from './upload-user-documents';
import { watcher as deleteUserDocuments } from './delete-user-documents';
import { watcher as deleteUserAttachment } from './delete-user-attachment';
import { watcher as deleteUserOutcomeAttachment } from './delete-user-outcome-attachment';
import { updateDocumentsSaga } from './updateDocumentsSaga';
import { updateAttachmentsSaga } from './updateAttachmentsSaga';
import { watcher as getGuardianDependentsWatcher } from './get-guardian-dependents';
import { watcher as editWorkingHoursWatcher } from './edit-working-hours';
import { profileRedirectSaga } from './my-profile-redirect';
import { publicProfileRedirectSaga } from './public-profile-redirect';
import { watcher as getMainConsents } from './get-main-consent';
// Patient Portal
import { watcher as vitalsActivityWatcher } from './patientHealthboard/vitals-activity-req';
import { watcher as historicMeasurementWatcher } from './patientHealthboard/historic-measurements-req';
import { watcher as stepsMeasurementWatcher } from './patientHealthboard/steps-measurements-req';
import { watcher as stepsMeasurementModalWatcher } from './patientHealthboard/steps-measurements-modal-req';
import { watcher as distanceMeasurementWatcher } from './patientHealthboard/distance-measurements-req';
import { watcher as distanceMeasurementModalWatcher } from './patientHealthboard/distance-measurements-modal-req';
import { watcher as bmiMeasurementWatcher } from './patientHealthboard/bmi-measurements-req';
import { watcher as bmiMeasurementModalWatcher } from './patientHealthboard/bmi-measurements-modal-req';
import { watcher as bloodGlucoseMeasurementWatcher } from './patientHealthboard/blood-glucose-measurements-req';
import { watcher as bloodGlucoseMeasurementModalWatcher } from './patientHealthboard/blood-glucose-measurements-modal-req';
import { watcher as weightMeasurementWatcher } from './patientHealthboard/weight-measurements-req';
import { watcher as weightMeasurementModalWatcher } from './patientHealthboard/weight-measurements-modal-req';
import { watcher as heightMeasurementWatcher } from './patientHealthboard/height-measurements-req';
import { watcher as heightMeasurementModalWatcher } from './patientHealthboard/height-measurements-modal-req';
import { watcher as saturationMeasurementWatcher } from './patientHealthboard/saturation-measurements-req';
import { watcher as saturationMeasurementModalWatcher } from './patientHealthboard/saturation-measurements-modal-req';
import { watcher as bodySurfaceAreaMeasurementWatcher } from './patientHealthboard/body-surface-area-measurements-req';
import { watcher as bodySurfaceAreaMeasurementModalWatcher } from './patientHealthboard/body-surface-area-measurements-modal-req';
import { watcher as heartRateMeasurementWatcher } from './patientHealthboard/heart-rate-measurements-req';
import { watcher as heartRateMeasurementModalWatcher } from './patientHealthboard/heart-rate-measurements-modal-req';
import { watcher as bloodPressureMeasurementWatcher } from './patientHealthboard/bloodPressure-measurements-req';
import { watcher as bloodPressureMeasurementModalWatcher } from './patientHealthboard/bloodPressure-measurements-modal-req';
import { watcher as respiratoryRateMeasurementWatcher } from './patientHealthboard/respiratoryRate-measurements-req';
import { watcher as respiratoryRateMeasurementModalWatcher } from './patientHealthboard/respiratoryRate-measurements-modal-req';
import { watcher as bodyTemperatureMeasurementWatcher } from './patientHealthboard/body-temperature-measurements-req';
import { watcher as bodyTemperatureMeasurementModalWatcher } from './patientHealthboard/body-temperature-measurements-modal-req';
import { watcher as addWeightDataWatcher } from './patientHealthboard/add-weight-data';
import { watcher as addHeightDataWatcher } from './patientHealthboard/add-height-data';
import { watcher as connectedDevicesWatcher } from './patientHealthboard/connected-devices';
import { watcher as providerAuthenticationsWatcher } from './patientHealthboard/provider-authentications';
import { watcher as providerListWatcher } from './patientHealthboard/provider-list';
import { watcher as removeAccountWatcher } from './patientHealthboard/remove-account';
import { handleAddWeightHeightSaga } from './patientHealthboard/handle-add-weight-height-saga';
import { manageDeviceAccountSaga } from './patientHealthboard/manage-device-account-saga';
import { watcher as insuranceEligibilityResultId } from './insurance-eligibility-manual-activations';
import { watchChangePatientInsuranceCard } from './sagas/patientInsurance/patient-insurance-card';
import { watcher as editPatientEmergencyContactWatcher } from './edit-patient-emergency-contact';

// MFA
import { watcher as mfaConfirmationsWatcher } from './mfa-confirmations';
import { watcher as enableMfaWatcher } from './mfa-enable';
import { watcher as disableMfaWatcher } from './mfa-disable';
import { watcher as mfaNoticeWatcher } from './mfa-notice';
import * as profileEditable from './profile-editable-req';
import { userSaga } from './user-saga';

export function* sagas() {
  yield fork(createPatientWatcher);
  yield fork(getUserWatcher);
  yield fork(getLoggedUserWatcher);
  yield fork(getTeamUserWatcher);
  yield fork(getProviderWatcher);
  yield fork(getProviderMemberWatcher);
  yield fork(getFamilyMemberWatcher);
  yield fork(getMainConsents);
  yield fork(editUserWatcher);
  yield fork(editAvatarWatcher);
  yield fork(editPatientWatcher);
  yield fork(editPatientByProviderWatcher);
  yield fork(editWorkingHoursWatcher);
  yield fork(editProviderWatcher);
  yield fork(editEmailWatcher);
  yield fork(editMobilePhoneWatcher);
  yield fork(confirmMobilePhoneWatcher);
  yield fork(updateAvatarSaga);
  yield fork(getParentMemberWatcher);
  yield fork(changeSettingsWatcher);
  yield fork(updateProfileSaga);
  yield fork(addPatientByProviderWatcher);
  yield fork(getAccessLevelsWatcher);
  yield fork(publicProfileWatcher);
  yield fork(getUserDocuments);
  yield fork(getUserAttachments);
  yield fork(uploadUserDocuments);
  yield fork(updateUserDocuments);
  yield fork(deleteUserDocuments);
  yield fork(updateDocumentsSaga);
  yield fork(updateAttachmentsSaga);
  yield fork(getGuardianDependentsWatcher);
  yield fork(profileRedirectSaga);
  yield fork(handleDocumentsErrorsSaga);
  yield fork(publicProfileRedirectSaga);
  yield fork(profileEditable.watcher);
  yield fork(userSaga);
  yield fork(mfaConfirmationsWatcher);
  yield fork(enableMfaWatcher);
  yield fork(disableMfaWatcher);
  yield fork(mfaNoticeWatcher);
  // Patient Portal
  yield fork(vitalsActivityWatcher);
  yield fork(bodyTemperatureMeasurementWatcher);
  yield fork(bodyTemperatureMeasurementModalWatcher);
  yield fork(bodySurfaceAreaMeasurementWatcher);
  yield fork(bodySurfaceAreaMeasurementModalWatcher);
  yield fork(heartRateMeasurementWatcher);
  yield fork(heartRateMeasurementModalWatcher);
  yield fork(saturationMeasurementWatcher);
  yield fork(saturationMeasurementModalWatcher);
  yield fork(bloodPressureMeasurementWatcher);
  yield fork(bloodPressureMeasurementModalWatcher);
  yield fork(respiratoryRateMeasurementWatcher);
  yield fork(respiratoryRateMeasurementModalWatcher);
  yield fork(distanceMeasurementWatcher);
  yield fork(distanceMeasurementModalWatcher);
  yield fork(stepsMeasurementWatcher);
  yield fork(stepsMeasurementModalWatcher);
  yield fork(bmiMeasurementWatcher);
  yield fork(bmiMeasurementModalWatcher);
  yield fork(bloodGlucoseMeasurementWatcher);
  yield fork(bloodGlucoseMeasurementModalWatcher);
  yield fork(weightMeasurementWatcher);
  yield fork(weightMeasurementModalWatcher);
  yield fork(heightMeasurementWatcher);
  yield fork(heightMeasurementModalWatcher);
  yield fork(historicMeasurementWatcher);
  yield fork(addWeightDataWatcher);
  yield fork(addHeightDataWatcher);
  yield fork(handleAddWeightHeightSaga);
  yield fork(connectedDevicesWatcher);
  yield fork(providerAuthenticationsWatcher);
  yield fork(providerListWatcher);
  yield fork(removeAccountWatcher);
  yield fork(manageDeviceAccountSaga);
  yield fork(changeProfileReqWatcher);
  yield fork(deleteUserAttachment);
  yield fork(deleteUserOutcomeAttachment);
  yield fork(insuranceEligibilityResultId);
  yield fork(editPatientEmergencyContactWatcher);

  yield fork(watchChangePatientInsuranceCard);
}



// WEBPACK FOOTER //
// ./src/redux/profiles/saga.js